<div class="vertical-bar-container" [style.height.px]="height">
    <canvas #verticalBar></canvas>
</div>